// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-plan-vfr-opening.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-plan-vfr-opening/flight-plan-vfr-opening.js';

mount([g0]);
